import { useForm } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { useAddTransfersMutation } from 'modules/banking/hooks/useAddTransfers'

export interface AddTransfersFormValues {
  paymentId: number
  transferIds: number[]
}

export const useAddTransfersForm = ({
  onSuccess,
  transferIds,
}: {
  onSuccess: () => void
  transferIds: number[]
}) => {
  const { submitAddTransfers: addTransfersBankingPayment, loading } = useAddTransfersMutation()

  const form = useForm<AddTransfersFormValues>({
    defaultValues: {
      paymentId: -1, // It's mandatory to set a default value for the paymentId, we set it to -1 to force an error if it's not provided
      transferIds: transferIds,
    },
    validateOnChange: false,
    validate: (values) => {
      const errors: Record<string, string> = {}

      if (values.paymentId === -1) {
        errors.paymentId = i18n.t('banking.bulk_payment.forms.validation_mandatory')
      }

      return errors
    },
    onSubmit: async (values) => {
      return await addTransfersBankingPayment({
        transferIds: values.transferIds,
        paymentId: values.paymentId,
        onSuccess: onSuccess,
      })
    },
  })

  return {
    form,
    loading,
  }
}
